import { configureStore } from '@reduxjs/toolkit';
import user, { resetUser, updateUserStripeIdentityVerified } from './slices/user';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import document, { resetDocuments } from './slices/document';
import advertisement from './slices/advertisement';
import organisation, { resetOrganisation } from './slices/organisation';
import verification, { resetVerification } from './slices/verification';
import sharedDocuments from './slices/sharedDocuments';
import candidateInterest from './slices/candidateInterest';
import notification from './slices/notification';
import preference from './slices/preference';
import advert, { resetAdverts } from './slices/advert';
import aiAssistant, { resetAIAssistant } from './slices/ai-assistant';
import dailyUpdates, { resetDailyUpdates } from './slices/daily-updates';
import admin, { resetAdmin } from './slices/admin';
import kbAdmin, { resetKbAdmin } from './slices/kb-admin';
import products, { resetProducts } from './slices/products';
import walletCategories, { resetWalletCategories } from './slices/walletCategories';
import advisorSupport, { resetAdvisorSupport } from './slices/advisorSupport';
import resourceHub, { resetResourceHub } from './slices/resourceHub';
import featureFlags from './slices/featureFlags';
import superchat from './slices/superchat';
import security from './slices/security';
import platformSettings from './slices/platformSettings';
import legalDocuments, { resetLegalDocuments } from './slices/legalDocuments';
import faqDocuments, { resetFaqDocuments } from './slices/faqDocuments';
import caseManagement from './slices/case-management';
import system, { resetSystem } from './slices/system';
import badges, { resetBadges } from './slices/badges';
import engagement, { resetEngagement } from './slices/engagement';
import partnerBranding, { resetPartnerBranding } from './slices/partnerBranding';
import leadShareOpportunities from './slices/leadShareOpportunities';
import leadShareInterests from './slices/leadShareInterests';
import leadShareConsents from './slices/leadShareConsents';
import schoolDirectory from './slices/schoolDirectory';
import schoolDirectoryAdmin from './slices/schoolDirectoryAdmin';
import emailTemplates, { resetEmailTemplates } from './slices/emailTemplates';
import { StripeIdentityVerificationStatus } from '../types/user';
export const store = configureStore({
	reducer: {
		user,
		organisation,
		document,
		preference,
		advertisement,
		verification,
		sharedDocuments,
		candidateInterest,
		notification,
		advert,
		aiAssistant,
		dailyUpdates,
		admin,
		kbAdmin,
		products,
		walletCategories,
		advisorSupport,
		resourceHub,
		featureFlags,
		superchat,
		security,
		platformSettings,
		legalDocuments,
		faqDocuments,
		caseManagement,
		system,
		badges,
		engagement,
		partnerBranding,
		leadShareOpportunities,
		leadShareInterests,
		leadShareConsents,
		schoolDirectory,
		schoolDirectoryAdmin,
		emailTemplates
	}
});

// export type RootState = ReturnType<typeof store.getState>
// // Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
// export type AppDispatch = typeof store.dispatch
// Infer the `RootState` and `AppDispatch` types from the store itself

export type RootState = ReturnType<typeof store.getState>;

// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}

export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export const resetStore = () => {
	store.dispatch(resetUser());
	store.dispatch(resetDocuments());
	store.dispatch(resetOrganisation());
	store.dispatch(resetVerification());
	store.dispatch(resetAdverts());
	store.dispatch(resetAIAssistant());
	store.dispatch(resetDailyUpdates());
	store.dispatch(resetAdmin());
	store.dispatch(resetKbAdmin());
	store.dispatch(resetProducts());
	store.dispatch(resetWalletCategories());
	store.dispatch(resetAdvisorSupport());
	store.dispatch(resetResourceHub());
	store.dispatch(resetSystem());
	store.dispatch(resetLegalDocuments());
	store.dispatch(resetFaqDocuments());
	store.dispatch(resetBadges());
	store.dispatch(resetEngagement());
	store.dispatch(resetPartnerBranding());
	store.dispatch(resetEmailTemplates());
	store.dispatch(updateUserStripeIdentityVerified(StripeIdentityVerificationStatus.NotStarted));
};
